import { putRequest } from 'lib/api-proxy-client';
import type { Bookmark, BookmarkPosition } from 'entities/bookmark';
import { bookmarkEndpoint } from './get';

export async function apiBookmarkPut(
  productGroup: string,
  lastVisited: BookmarkPosition,
): Promise<Bookmark> {
  return (
    await putRequest(bookmarkEndpoint(productGroup), { lastVisited })
  ).json();
}
